// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0_postcss@8.4.41_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.93.0_postcss@8.4.41_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.sc-title[data-v-07194c8b] {\r\n  border-bottom: 1px solid #eee;\r\n  margin-bottom: 20px;\r\n  font-size: 17px;\r\n  padding-bottom: 15px;\r\n  color: #3c4a54;\r\n  font-weight: bold;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
